import _ from "lodash";
import { LocaleConfig } from "__SYSDefault/Locale";

import { Accessor, ColorX, GState } from "IZOX/STATIC";

class LocaleX {

  static GetIZO(accessor, mapping = {}, lang = GState.lang){
    return this.Get("__IZO." + accessor, mapping, lang = GState.lang);
  }

  /**
   * Get Locale String from LocaleConfig
   * @param {String} accessor 
   * @param {*} mapping replace @[field] to value
   * @returns 
   */
  static Get(accessor, mapping = {}, lang = GState.lang){
    let langO = LocaleConfig.find(o => o.code === lang);
    let lib = langO.lib;

    let str = Accessor.Get(lib, accessor);
    if(!_.isEmpty(str) && !_.isString(str)) {
      console.warn("Not Type of String <" + lang + ">: " + accessor);
      return str;
    }

    if(_.isEmpty(str)){
      console.warn("No locale ID <" + lang + ">: " + accessor);
      return str;
    }
    
    _.map(mapping, (o, i) => {
      str = str.replace("@" + i, o);
    });

    return str;

  }

  /**
   * 
   * @param {Object.<string, String>} obj 
   * @param {*} mapping 
   * @returns 
   */
  static Parse(obj, mapping = {}, lang = GState.lang){
    let str = "";
    if(!obj) return "";
    if(_.isString(obj)){
      str = obj;
    }else{
      if(!obj[lang] || _.isEmpty(obj[lang])){
        console.log("%cLocaleX :: No locale Key <" + lang + ">",  
          "color: " + ColorX.CSS("yellow"), obj);
        return obj["EN"] ?? "";
      }
      str = obj[lang];
    }
    
    _.map(mapping, (o, i) => {
      str = str.replace("@" + i, o);
    });

    return str;
  }

}

export default LocaleX;